import {Dialog, Slide, Stack, Typography} from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import {forwardRef} from "react";
import LoadoutDisplay from "./LoadoutDisplay";


const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


function ShareLoadout({weapon, attachments, open, setOpen, label}) {
    return (
        <Stack direction='row' onClick={() => setOpen(true)}>
            {label ? <Typography sx={{mr: '6px', color: 'white', fontSize: '0.9rem', userSelect: 'none'}}>Share</Typography> : null}
            <ShareIcon sx={{paddingRight: '10px'}}/>
            <Dialog onClose={(e) => {setOpen(false); e.stopPropagation()}} open={open} maxWidth='70vw' TransitionComponent={Transition}>
                    <LoadoutDisplay weapon={weapon} attachments={attachments}/>
            </Dialog>
        </Stack>
    )
}

export default ShareLoadout